module.exports = __webpack_public_path__ + "img/pt3.d5ea7db1.png";